import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementCollectDocument } from '@onefootprint/request-types';
import upperFirst from 'lodash/upperFirst';
import PhotoCapture from '../../../components/photo-capture';
import type { CameraErrorCause, ReceivedImagePayload } from '../../../types';
const OUTLINE_HEIGHT_RATIO = 0.9;
const OUTLINE_WIDTH_RATIO = 0.9;
type MobileImageCaptureViewProps = {
  docName: string;
  requirement: OnboardingRequirementCollectDocument;
  hasBadConnectivity: boolean | undefined;
  allowPdf: boolean;
  onComplete: (payload: ReceivedImagePayload) => void;
  onBack: () => void;
  onCameraError: (cause: CameraErrorCause) => void;
  onCameraAccessDenied: () => void;
  onCameraStuck: () => void;
};
const MobileImageCaptureView = t0 => {
  const $ = _c(18);
  const {
    docName,
    requirement,
    hasBadConnectivity,
    allowPdf,
    onComplete,
    onBack,
    onCameraError,
    onCameraAccessDenied,
    onCameraStuck
  } = t0;
  let t1;
  if ($[0] !== docName) {
    t1 = upperFirst(docName);
    $[0] = docName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== docName) {
    t2 = upperFirst(docName);
    $[2] = docName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      camera: t1,
      preview: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== allowPdf || $[8] !== docName || $[9] !== hasBadConnectivity || $[10] !== onBack || $[11] !== onCameraAccessDenied || $[12] !== onCameraError || $[13] !== onCameraStuck || $[14] !== onComplete || $[15] !== requirement || $[16] !== t3) {
    t4 = <PhotoCapture autocaptureKind="nonIdDoc" cameraKind="back" deviceKind="mobile" allowPdf={allowPdf} docName={docName} requirement={requirement} hasBadConnectivity={hasBadConnectivity} onCameraErrored={onCameraError} onCameraAccessDenied={onCameraAccessDenied} onCameraStuck={onCameraStuck} onComplete={onComplete} onBack={onBack} outlineHeightRatio={OUTLINE_HEIGHT_RATIO} outlineWidthRatio={OUTLINE_WIDTH_RATIO} title={t3} />;
    $[7] = allowPdf;
    $[8] = docName;
    $[9] = hasBadConnectivity;
    $[10] = onBack;
    $[11] = onCameraAccessDenied;
    $[12] = onCameraError;
    $[13] = onCameraStuck;
    $[14] = onComplete;
    $[15] = requirement;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
export default MobileImageCaptureView;